/// <reference path="./entries/NullEntry.class.ts" />

namespace SPA
{
	export namespace Organization
	{

		export namespace gui
		{
			export class OrgaTree
				extends ui.tab.TabHTMLPresentation
			{

				private tree: ui.Box.Box;
				private details: AbstractEntry;
				private m_Object: Wollmilch.CompanyObject;

				public constructor( obj: Wollmilch.CompanyObject )
				{
					super( 'div' );

					this.m_Object = obj;

					/*
						* Erstelle generelles Layout
						*		-- Baumansicht
						*		-- Detailansicht

						* Lade die Struktur der übergebenen Firma
						* -> Erstelle Baumstruktur

						! Erstelle für jedes der Typen eine konkrete Darstellungsklasse
						! -> Für die Firma ein besonderer Typ für zusätzliche Konfigurationen, vllt
						!    als Möglichkeit in der Baumstruktur selbst
					*/
					this.addClass('row');
					// this.css(
					// 	{
					// 		'display': 'flex',
					// 		'flex-direction': 'row',
					// 		'justify-content': 'flex-start',
					// 		'align-items': 'stretch',
					// 		'position': "relative",
					// 		'height': '100%'
					// 	}
					// );

					this.tree = new ui.Box.Box( true );
					this.details = new CompanyEntry( this.m_Object, this );

					this.tree.addTitle( 'Unternehmensstruktur' );
					this.tree.addClass('col-xs-12 col-lg-3 box-style');
					this.tree.css(
						{
							'overflow-y': 'auto'
						}
					);

					$('html').on('reloadOrgaTree', () => {
						this.reload();
					});
				}

				public reload(): void
				{
					if ( this.m_Entry )
					{
						this.m_Entry.ActivateReloadSpin();
					}

					this.empty();
					this.loadOrganization( this.m_Object );

					if ( this.m_Entry )
					{
						this.m_Entry.DeactivateReloadSpin();
					}
				}

				public setDetails( entry: AbstractEntry|null ): void
				{
					this.details.empty();
					this.details.remove();

					this.details = entry || new NullEntry( this );

					this.details.rebuild( this );
				}

				public rebuild( root: ui.base.BaseHTMLElement, ...data: any[] ): ui.tab.TabHTMLPresentation
				{
					this.empty();
					this.remove();

					super.rebuild( root );

					this.loadOrganization( this.m_Object );

					if ( this.m_Entry )
					{
						this.m_Entry.DeactivateReloadSpin();
					}

					return this;
				}

				private loadOrganization( p_Obj: Wollmilch.CompanyObject ): void
				{
					this.tree.empty();
					this.details.empty();

					this.tree.rebuild( this );
					this.details.rebuild( this );

					new Wollmilch.AJAX(
						{
							method: 'GET',
							url: 'organization/deeplist/' + p_Obj.ID,
							on:
							{
								success: ( text: string ): void =>
								{
									const obj = Wollmilch.jsonize( text );

									if ( obj === null || obj.data === undefined )
									{
										app.addNotify(
											{
												context: "danger",
												title: [ "Fehler" ],
												timeout: Number(app.getConfigValue("ToastTimeout")),
												body: [ "Die Unternehmensdaten konnten nicht geladen werden." ]
											}
										);

										return;
									}

									const root = OrgaTreeFactory.createNode(
										this,
										p_Obj,
										new ui.base.BaseHTMLElement('ul').appendTo(
											new ui.base.BaseHTMLElement('orga-tree-view').appendTo( this.tree )
										)
									);

									if ( root === undefined )
									{
										return;
									}

									(obj.data as Wollmilch.ComponentObject[]).forEach(
										( e: Wollmilch.ComponentObject ) => OrgaTreeFactory.createNode( this, e, root )
									);

									root.rebuild();
								}
							}
						}
					).send();
				}

			}
		}
	}
}
